import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOItem } from "../models/BOItem.model";
import { BOToothFaceType } from "../models/odo/BOToothFaceType.model";

@Injectable({
  providedIn: 'root'
})
export class ToothFaceTypeService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/ToothFaceType';

    constructor(private http:HttpClient){}

    getAll():Observable<BOToothFaceType[]>{
        return this.http.get<BOToothFaceType[]>(this.myAppUrl + this.myApiUrl);
    }
}
